import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  concateString,
  NO_OF_BANK_ACCOUNT_HOLDER_COLUMN,
  NO_OF_BANK_ACCOUNT_NO_COLUMN,
  NO_OF_BANK_BRANCH_COLUMN,
  NO_OF_BANK_COLUMN,
  NO_OF_BANK_SUFFIX_COLUMN,
  NO_OF_BUSINESS_NAME_COLUMN,
} from "../common/interactiveCommon";
import KS10Address from "./KS10Address";
import KS10BankDetail from "./KS10BankDetail";
import KS10BusinessName from "./KS10BusinessName";
import KS10ContactInfo from "./KS10ContactInfo";
import KS10Email from "./KS10Email";
import KS10Header from "./KS10Header";
import KS10IRDNumber from "./KS10IRDNumber";
import KS10LeftoutReason from "./KS10LeftoutReason";
import KS10Name from "./KS10Name";
import KS10NameSalutation from "./KS10NameSalutation";
import KS10Notes from "./KS10Notes";
import KS10SectionAHeader from "./KS10SectionAHeader";
import KS10SectionBHeader from "./KS10SectionBHeader";
import KS10SectionCHeader from "./KS10SectionCHeader";
import KS10Sign from "./KS10Sign";
import KS10EmploymentStartDate from "./KS10EmployementStartDate";
import { cloneDeep } from "lodash";
import { errorState } from "../../../recoil/error/atom";
import { useSetRecoilState } from "recoil";
import validateDate from "../common/ValidationHelper";
import Button from "react-bootstrap/Button";
const KS10 = (props) => {
  const popError = useSetRecoilState(errorState);

  const NO_OF_NAME_COLUMN = 37;
  const NO_OF_SURNAME_COLUMN = 31;
  const NO_OF_STREET_NUMBER_COLUMN = 6;
  const NO_OF_STREET_ADDRESS_COLUMN = 24;
  const NO_OF_SUBURB_COLUMNS = 15;
  const NO_OF_POST_CODE_COLUMNS = 4;
  const NO_OF_PHONE_NO_COLUMNS = 9;
  const NO_OF_MOBILE_NO_COLUMNS = 11;
  const NO_OF_EMAIL_COLUMNS = 62;
  const [iRDs, setIRDs] = useState(new Array(9).fill(""));
  const [nameTitleOther, setNameTitleOther] = useState(new Array(6).fill(""));
  const [selectedTitle, setSelectedTitle] = useState("");
  const [firstName, setFirstName] = useState(new Array(NO_OF_NAME_COLUMN).fill(""));
  const [surname, setSurname] = useState(new Array(NO_OF_SURNAME_COLUMN).fill(""));
  const [streetNumber, setStreetNumber] = useState(new Array(NO_OF_STREET_NUMBER_COLUMN).fill(""));
  const [streetAddress, setStreetAddress] = useState(new Array(NO_OF_STREET_ADDRESS_COLUMN).fill(""));
  const [subUrb, setSubUrb] = useState(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
  const [town, setTown] = useState(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
  const [postCode, setPostCode] = useState(new Array(NO_OF_POST_CODE_COLUMNS).fill(""));
  const [day, setDay] = useState(new Array(NO_OF_PHONE_NO_COLUMNS).fill("")); //Note: Here we are using day variable to be align with KS2 Pdf text.
  const [mobile, setMobile] = useState(new Array(NO_OF_MOBILE_NO_COLUMNS).fill(""));
  const [email, setEmail] = useState(new Array(NO_OF_EMAIL_COLUMNS).fill(""));
  const [bank, setBank] = useState(new Array(NO_OF_BANK_COLUMN).fill(""));
  const [bankBranch, setBankBranch] = useState(new Array(NO_OF_BANK_BRANCH_COLUMN).fill(""));
  const [bankAccountNumber, setBankAccountNumber] = useState(new Array(NO_OF_BANK_ACCOUNT_NO_COLUMN).fill(""));
  const [bankSuffix, setBankSuffix] = useState(new Array(NO_OF_BANK_SUFFIX_COLUMN).fill(""));
  const [bankAccountHolder, setbankAccountHolder] = useState(new Array(NO_OF_BANK_ACCOUNT_HOLDER_COLUMN).fill(""));
  const [day1, setDay1] = useState("");
  const [day2, setDay2] = useState("");
  const [month1, setMonth1] = useState("");
  const [month2, setMonth2] = useState("");
  const [year3, setYear3] = useState("");
  const [year4, setYear4] = useState("");
  const [signature, setSignature] = useState("");
  const [eIRDs, setEIRDs] = useState(new Array(9).fill(""));
  const [businessName, setBusinessName] = useState(new Array(NO_OF_BUSINESS_NAME_COLUMN).fill(""));
  //Employment start date
  const [eday1, setEDay1] = useState("");
  const [eday2, setEDay2] = useState("");
  const [emonth1, setEMonth1] = useState("");
  const [emonth2, setEMonth2] = useState("");
  const [eyear3, setEYear3] = useState("");
  const [eyear4, setEYear4] = useState("");
  const [leftoutReason, setLeftoutReason] = useState("");

  const setIRDData = ({ name, value }) => {
    const isEIRD = name.indexOf("EIRD") >= 0;
    const index = parseInt(name.replace(isEIRD ? "EIRD" : "IRD", ""), 10);
    let newCopyiRDs = cloneDeep(isEIRD ? eIRDs : iRDs);
    newCopyiRDs[index - 1] = value;
    if (isEIRD) {
      setEIRDs(newCopyiRDs);
    } else {
      setIRDs(newCopyiRDs);
    }
  };

  const setMemberData = (name) => {
    setSelectedTitle(name);
  };

  const clearOther = () => {
    setNameTitleOther(new Array(6).fill(""));
  };

  const setNameTitleOtherData = ({ name, value }) => {
    const index = parseInt(name.replace("nameTitleOther", ""), 10);
    let newCopyNameTitleOther = cloneDeep(nameTitleOther);
    newCopyNameTitleOther[index - 1] = value;
    setNameTitleOther(newCopyNameTitleOther);
  };

  const setName = ({ name, value }) => {
    if (name.indexOf("firstName") >= 0) {
      const index = parseInt(name.replace("firstName", ""), 10);
      let newCopyFirstName = cloneDeep(firstName);
      newCopyFirstName[index - 1] = value;
      setFirstName(newCopyFirstName);
    } else if (name.indexOf("surname") >= 0) {
      const index = parseInt(name.replace("surname", ""), 10);
      let newCopyLastName = cloneDeep(surname);
      newCopyLastName[index - 1] = value;
      setSurname(newCopyLastName);
    }
  };

  const setAdrress = ({ name, value }) => {
    if (name.indexOf("streetNumber") >= 0) {
      const index = parseInt(name.replace("streetNumber", ""), 10);
      let newCopyOfData = cloneDeep(streetNumber);
      newCopyOfData[index - 1] = value;
      setStreetNumber(newCopyOfData);
    } else if (name.indexOf("streetAddress") >= 0) {
      const index = parseInt(name.replace("streetAddress", ""), 10);
      let newCopyOfData = cloneDeep(streetAddress);
      newCopyOfData[index - 1] = value;
      setStreetAddress(newCopyOfData);
    } else if (name.indexOf("subUrb") >= 0) {
      const index = parseInt(name.replace("subUrb", ""), 10);
      let newCopyOfData = cloneDeep(subUrb);
      newCopyOfData[index - 1] = value;
      setSubUrb(newCopyOfData);
    } else if (name.indexOf("town") >= 0) {
      const index = parseInt(name.replace("town", ""), 10);
      let newCopyOfData = cloneDeep(town);
      newCopyOfData[index - 1] = value;
      setTown(newCopyOfData);
    } else if (name.indexOf("postCode") >= 0) {
      const index = parseInt(name.replace("postCode", ""), 10);
      let newCopyOfData = cloneDeep(postCode);
      newCopyOfData[index - 1] = value;
      setPostCode(newCopyOfData);
    }
  };

  const setBankData = ({ name, value }) => {
    if (name.indexOf("bankAccountNumber") >= 0) {
      const index = parseInt(name.replace("bankAccountNumber", ""), 10);
      let newCopyOfData = cloneDeep(bankAccountNumber);
      newCopyOfData[index - 1] = value;
      setBankAccountNumber(newCopyOfData);
    } else if (name.indexOf("bankBranch") >= 0) {
      const index = parseInt(name.replace("bankBranch", ""), 10);
      let newCopyOfData = cloneDeep(bankBranch);
      newCopyOfData[index - 1] = value;
      setBankBranch(newCopyOfData);
    } else if (name.indexOf("bankSuffix") >= 0) {
      const index = parseInt(name.replace("bankSuffix", ""), 10);
      let newCopyOfData = cloneDeep(bankSuffix);
      newCopyOfData[index - 1] = value;
      setBankSuffix(newCopyOfData);
    } else if (name.indexOf("bankAccountHolder") >= 0) {
      const index = parseInt(name.replace("bankAccountHolder", ""), 10);
      let newCopyOfData = cloneDeep(bankAccountHolder);
      newCopyOfData[index - 1] = value;
      setbankAccountHolder(newCopyOfData);
    } else if (name.indexOf("bank") >= 0) {
      const index = parseInt(name.replace("bank", ""), 10);
      let newCopyOfData = cloneDeep(bank);
      newCopyOfData[index - 1] = value;
      setBank(newCopyOfData);
    }
  };

  const setContactNumber = ({ name, value }) => {
    if (name.indexOf("DAY") >= 0) {
      const index = parseInt(name.replace("DAY", ""), 10);
      let newCopyOfData = cloneDeep(day);
      newCopyOfData[index - 1] = value;
      setDay(newCopyOfData);
    } else if (name.indexOf("mobile") >= 0) {
      const index = parseInt(name.replace("mobile", ""), 10);
      let newCopyOfData = cloneDeep(mobile);
      newCopyOfData[index - 1] = value;
      setMobile(newCopyOfData);
    }
  };

  const setEmailData = ({ name, value }) => {
    if (name.indexOf("email") >= 0) {
      const index = parseInt(name.replace("email", ""), 10);
      let newCopyOfData = cloneDeep(email);
      newCopyOfData[index - 1] = value;
      setEmail(newCopyOfData);
    }
  };

  const setBusinessNameData = ({ name, value }) => {
    if (name.indexOf("businessName") >= 0) {
      const index = parseInt(name.replace("businessName", ""), 10);
      let newCopyOfData = cloneDeep(businessName);
      newCopyOfData[index - 1] = value;
      setBusinessName(newCopyOfData);
    }
  };

  const setSignatureData = (data) => setSignature(data);
  const setDateData = ({ name, value }) => {
    switch (name) {
      case "day1":
        setDay1(value);
        break;
      case "day2":
        setDay2(value);
        break;
      case "month1":
        setMonth1(value);
        break;
      case "month2":
        setMonth2(value);
        break;
      case "year3":
        setYear3(value);
        break;
      case "year4":
        setYear4(value);
        break;
      default:
        break;
    }
  };

  const setEmploymentStartDate = ({ name, value }) => {
    switch (name) {
      case "eday1":
        setEDay1(value);
        break;
      case "eday2":
        setEDay2(value);
        break;
      case "emonth1":
        setEMonth1(value);
        break;
      case "emonth2":
        setEMonth2(value);
        break;
      case "eyear3":
        setEYear3(value);
        break;
      case "eyear4":
        setEYear4(value);
        break;
      default:
        break;
    }
  };

  const resetForm = () => {
    setIRDs(new Array(9).fill(""));
    setNameTitleOther(new Array(6).fill(""));
    setSelectedTitle("");
    setFirstName(new Array(NO_OF_NAME_COLUMN).fill(""));
    setSurname(new Array(NO_OF_SURNAME_COLUMN).fill(""));
    setStreetNumber(new Array(NO_OF_STREET_NUMBER_COLUMN).fill(""));
    setStreetAddress(new Array(NO_OF_STREET_ADDRESS_COLUMN).fill(""));
    setSubUrb(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
    setTown(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
    setPostCode(new Array(NO_OF_POST_CODE_COLUMNS).fill(""));
    setDay(new Array(NO_OF_PHONE_NO_COLUMNS).fill("")); //Note: Here we are using day variable to be align with KS2 Pdf text.
    setMobile(new Array(NO_OF_MOBILE_NO_COLUMNS).fill(""));
    setEmail(new Array(NO_OF_EMAIL_COLUMNS).fill(""));
    setBank(new Array(NO_OF_BANK_COLUMN).fill(""));
    setBankBranch(new Array(NO_OF_BANK_BRANCH_COLUMN).fill(""));
    setBankAccountNumber(new Array(NO_OF_BANK_ACCOUNT_NO_COLUMN).fill(""));
    setBankSuffix(new Array(NO_OF_BANK_SUFFIX_COLUMN).fill(""));
    setbankAccountHolder(new Array(NO_OF_BANK_ACCOUNT_HOLDER_COLUMN).fill(""));
    setDay1("");
    setDay2("");
    setMonth1("");
    setMonth2("");
    setYear3("");
    setYear4("");
    setSignature("");
    setEIRDs(new Array(9).fill(""));
    setBusinessName(new Array(NO_OF_BUSINESS_NAME_COLUMN).fill(""));
    //Employment start date
    setEDay1("");
    setEDay2("");
    setEMonth1("");
    setEMonth2("");
    setEYear3("");
    setEYear4("");
    setLeftoutReason("");
  };

  const validateForm = (formData) => {
    const isRequiredFieldsFilled =
      formData.firstName &&
      formData.surName &&
      formData.ird1 &&
      formData.ird2 &&
      formData.ird3 &&
      formData.bankAccountNumber;

    const isSignatureAndDateValid = signature && formData.day && formData.month && formData.year;

    if (isRequiredFieldsFilled && isSignatureAndDateValid) {
      const isValidDate = validateDate(formData.day, formData.month, formData.year);
      if (!isValidDate) {
        return {
          isValid: false,
          message: "Signature date is invalid. Enter date in DD-MM-YYYY format e.g. 27/10/2025",
        };
      }
      return { isValid: true };
    }
    return {
      isValid: false,
      message:
        "All mandatory fields must be completed: First name, Surname, IRD number, Bank account number, Signature and Date.",
    };
  };

  const submitForm = () => {
    const sigDay = day1 + day2;
    const sigMonth = month1 + month2;
    const sigYear = year3 + year4;
    const nameString = concateString(firstName);
    const surnameString = concateString(surname);
    const streetNumberString = concateString(streetNumber);
    const streetAddressString = concateString(streetAddress);
    const subUrbString = concateString(subUrb);
    const townString = concateString(town);
    const postCodeString = concateString(postCode);

    const emailString = concateString(email);
    const bankString = concateString(bank);
    const bankBranchString = concateString(bankBranch);
    const bankSuffixString = concateString(bankSuffix);
    const bankAccountHolderString = concateString(bankAccountHolder);
    const bankAccountNumberString = concateString(bankAccountNumber);
    const businessNameString = concateString(businessName);
    const salutation = ["Mr", "Mrs", "Miss", "Ms", "Other"];

    const data = {
      interactiveDocument: "KS10",
      ird1: iRDs.slice(0, 3).join(""),
      ird2: iRDs.slice(3, 6).join(""),
      ird3: iRDs.slice(6).join(""),
      tick: salutation.indexOf(selectedTitle),
      nameTitle: nameTitleOther.join(""),
      firstName: nameString,
      surName: surnameString,
      streetNumber: streetNumberString,
      streetAddress: streetAddressString,
      subUrb: subUrbString,
      town: townString,
      postCode: postCodeString,

      telephone3: day.slice(5).join(""),
      telephone1: day.slice(0, 2).join(""),
      telephone2: day.slice(2, 5).join(""),
      mobile1: mobile.slice(0, 3).join(""),
      mobile2: mobile.slice(3, 6).join(""),
      mobile3: mobile.slice(6).join(""),
      email1: emailString.substring(0, 31),
      email2: emailString.substring(31),
      bank: bankString,
      bankBranch: bankBranchString,
      bankAccountNumber: bankAccountNumberString,
      bankSuffix: bankSuffixString,
      bankAccountHolder: bankAccountHolderString,
      emonth: emonth1 + emonth2,
      eday: eday1 + eday2,
      eyear: "20" + eyear3 + eyear4,
      ird4: eIRDs.slice(0, 3).join(""),
      ird5: eIRDs.slice(3, 6).join(""),
      ird6: eIRDs.slice(6).join(""),
      businessName1: businessNameString.substring(0, 37),
      businessName2: businessNameString.substring(37),
      day: sigDay,
      month: sigMonth,
      year: "20" + sigYear,
      leftoutReason,
      signatureContent: signature,
    };

    const { isValid, message } = validateForm(data);

    if (isValid) {
      props.submit(data).then((result) => {
        if (result) {
          props.redirectToList();
        }
      });
    } else {
      popError([
        {
          type: "warning",
          title: "Warning",
          message: message,
        },
      ]);
    }
  };

  return (
    <div className="ks-10-form">
      <KS10Header />
      <div className="container mid-container pt-0">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <h2 className="page-title pb-0 mb-0 mt-0">Opt-out request</h2>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 kiwisaver-act">KiwiSaver Act 2006</div>
        </div>
        <div className="tcd-form-details">
          <div className="px-4 pt-3">
            <p className="fontsize-18">
              Use this form to opt out if you have been automatically enrolled, are a minor who was incorrectly
              enrolled, and you don’t want to be a member of KiwiSaver. Or go to <strong>ird.govt.nz/kiwisaver</strong>{" "}
              to complete our online form. <strong>Read the notes on the back to help you fill in this form.</strong>
            </p>
          </div>
          <form>
            <KS10SectionAHeader />
            <div className="tcd-innerdetails pb-3">
              <KS10IRDNumber
                IRD={iRDs}
                setIRDData={setIRDData}
                keyName={"IRD"}
                serialNumber={"1"}
                title={"Your IRD number"}
                message={"If you don’t know your IRD number or you don’t have one, call us on 0800 549 472"}
              />
              <KS10NameSalutation
                setSalutation={setMemberData}
                setNameTitleOtherData={setNameTitleOtherData}
                nameTitleOther={nameTitleOther}
                clearOther={clearOther}
              />
              <KS10Name
                count={NO_OF_NAME_COLUMN}
                keyName={"firstName"}
                name={firstName}
                setName={setName}
                smallTitleLabel={"First names"}
              />
              <KS10Name
                count={NO_OF_SURNAME_COLUMN}
                keyName={"surname"}
                name={surname}
                setName={setName}
                smallTitleLabel={"Surname"}
                refDivClass="w-100"
              />
              <KS10Address
                streetNumber={streetNumber}
                streetAddress={streetAddress}
                subUrb={subUrb}
                town={town}
                postCode={postCode}
                setAddressData={setAdrress}
              />
              <KS10ContactInfo day={day} mobile={mobile} setContactNumber={setContactNumber} />
              <KS10Email email={email} setEmail={setEmailData} />
              <KS10BankDetail
                bank={bank}
                bankAccountNumber={bankAccountNumber}
                bankBranch={bankBranch}
                bankSuffix={bankSuffix}
                bankAccountHolder={bankAccountHolder}
                setBankData={setBankData}
              />
              <KS10Sign
                setDateData={setDateData}
                setSignatureData={setSignatureData}
                day1={day1}
                day2={day2}
                month1={month1}
                month2={month2}
                year3={year3}
                year4={year4}
                signature={signature}
              />
            </div>
            <KS10SectionBHeader />
            <div className="tcd-innerdetails pb-3">
              <KS10IRDNumber
                IRD={eIRDs}
                setIRDData={setIRDData}
                keyName={"EIRD"}
                serialNumber={"8"}
                title={"Employer's IRD number"}
                message={"If you don’t have your employer’s IRD number ask them for it."}
              />
              <KS10BusinessName businessName={businessName} setBusinessNameData={setBusinessNameData} />
              <KS10EmploymentStartDate
                setDateData={setEmploymentStartDate}
                eday1={eday1}
                eday2={eday2}
                emonth1={emonth1}
                emonth2={emonth2}
                eyear3={eyear3}
                eyear4={eyear4}
              />
            </div>
            <KS10SectionCHeader />
            <div className="tcd-innerdetails pb-3">
              <KS10LeftoutReason leftoutReason={leftoutReason} setLeftoutReason={setLeftoutReason} />
              <div className="row">
                <div className="reset-form-btn text-right pr-4 col-sm-12 col-md-12 col-lg-12">
                  <Button type="reset" onClick={resetForm}>
                    RESET FORM
                  </Button>
                  &nbsp;&nbsp;
                  <Button type="button" onClick={submitForm}>
                    SUBMIT FORM
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="pagebreak" />
        <KS10Notes />
      </div>
    </div>
  );
};
KS10.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default KS10;
